import { render } from "./HandlingCompletedPanel.vue?vue&type=template&id=4729002a"
import script from "./HandlingCompletedPanel.vue?vue&type=script&lang=js"
export * from "./HandlingCompletedPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__